import { CITATION_ID_PATTERN } from "./utils/citationId";

let backendDomain;
let apiUrl, webSocketUrl, frontendUrl, searchApiUrl;
let requireAnswerRating = true;
let apiV2Url;
let mcpUrl;

export const ENV = import.meta.env.VITE_ENV;
export const IMPERSONATE_USER_ID = import.meta.env.VITE_IMPERSONATE_USER_ID;

if (ENV && ENV == "local") {
  // Per-worktree slot system: VITE_LOCAL_BACKEND_PORT is injected by start.sh
  // so a slot's frontend hits its own backend (slot 0 = 8000, slot N = 8000+100*N).
  const localBackendPort = import.meta.env.VITE_LOCAL_BACKEND_PORT || "8000";
  backendDomain = `localhost:${localBackendPort}`;
  apiUrl = `http://localhost:${localBackendPort}/api/v1`;
  apiV2Url = `http://localhost:${localBackendPort}`;
  webSocketUrl = `ws://localhost:${localBackendPort}/ws`;
  frontendUrl = document.location.origin;
  searchApiUrl = "http://localhost:8080/api/v1";
  mcpUrl = "http://localhost:18765";
  requireAnswerRating = false;

  // backendDomain = "api.stage.finpilotai.com";
  // apiUrl = "https://api.stage.finpilotai.com/api/v1";
  // apiV2Url = "https://api.stage.finpilotai.com";
  // webSocketUrl = "wss://api.stage.finpilotai.com/ws";
  // frontendUrl = "https://stage.finpilotai.com";
  // searchApiUrl = "https://search.stage.finpilotai.com/api/v1";
} else if (ENV && ENV == "stage") {
  backendDomain = "api.stage.finpilotai.com";
  apiUrl = "https://api.stage.finpilotai.com/api/v1";
  apiV2Url = "https://api.stage.finpilotai.com";
  webSocketUrl = "wss://api.stage.finpilotai.com/ws";
  frontendUrl = "https://stage.finpilotai.com";
  searchApiUrl = "https://search.stage.finpilotai.com/api/v1";
  mcpUrl = "https://mcp.stage.finpilotai.com";
} else if (ENV && ENV == "tenant") {
  // Isolated tenant deployment (#11587): UI and API are served from ONE
  // origin (the tenant's own ALB routes / to the UI and /api/* + /ws to the
  // backend), so every endpoint derives from the page's origin at runtime.
  // One build therefore serves any tenant domain — no per-tenant rebuild.
  backendDomain = document.location.host;
  apiUrl = `${document.location.origin}/api/v1`;
  apiV2Url = document.location.origin;
  webSocketUrl = `${document.location.origin.replace(/^http/, "ws")}/ws`;
  frontendUrl = document.location.origin;
  // Not tenant workloads; same-origin paths 404 harmlessly if reached.
  searchApiUrl = `${document.location.origin}/api/v1`;
  mcpUrl = document.location.origin;
} else {
  backendDomain = "api.finpilotai.com";
  apiUrl = "https://api.finpilotai.com/api/v1";
  apiV2Url = "https://api.finpilotai.com";
  webSocketUrl = "wss://api.finpilotai.com/ws";
  frontendUrl = "https://app.finpilotai.com";
  searchApiUrl = "https://search.finpilotai.com/api/v1";
  mcpUrl = "https://mcp.finpilotai.com";
}
let logServerUrl = "https://logs.finpilotai.com";

export const BACKEND_DOMAIN = backendDomain;
export const BASE_API_URL = apiUrl;
export const BASE_API_URL_V2 = apiV2Url;
export const BASE_WS_URL = webSocketUrl;
export const BASE_FRONTEND_URL = frontendUrl;
export const BASE_SEARCH_API_URL = searchApiUrl;
export const BASE_MCP_URL = mcpUrl;
export const REDUX_SERVER_URL = "https://redux.finpilotai.com";
export const FORCED_RATING = requireAnswerRating;
export const GET_KEYWORD_RESULTS = false;
export const MAX_NUM_CONTEXT_PER_PROMPT = 10;
export const MAX_TOKENS_CHAT = 14000;
export const MAX_ANSWER_CONTEXT = 16;
export const MAX_TABS = 8;
export const LOG_SERVER_URL = logServerUrl;
export const AVERAGE_TOKEN_LENGTH = 3.5;
export const DEFAULT_SOURCES = [
  "web",
  "10-K",
  "10-Q",
  // "8-K",
  // "DEF 14A",
  "earnings_call_transcript",
];

// TIMEOUTS
export const WEB_SEARCH_TIMEOUT = 60 * 1000;
export const GET_RELEVANT_DOCS_TIMEOUT = 20 * 1000;
export const FP_LOADER_TIMEOUT = 60 * 1000;
export const ANSWERS_LOADER_TIMEOUT = 60 * 1000;
export const TAB_TITLE_TIMEOUT = 7 * 1000;
export const XF_DATA_TIMEOUT = 10 * 1000;
export const QUERY_RESOLUTION_TIMEOUT = 30 * 1000;
export const HTML_DOCUMENT_DOWNLOAD_TIMEOUT = 60 * 1000;
export const OPEN_URLS = ["/reset", "/help", "/chat/share"];
export const RETRY_QUERY_TIMEOUT = 15 * 1000;
export const assistant_status = {
  FINDING_INFORMATION: "pulling information",
  ASSISTANT_THINKING: "thinking",
  ASSISTANT_THINKING_SUGGESTIONS: "generating suggestions",
  ASSISTANT_TYPING: "typing",
};
export const DUMMY_FILE_ID = "dummyfile_s624";
export const ROOT_NODE_ID = "root_s971";
export const LOGIN_SESSION_DURATION_MINUTES = 2 * 30 * 24 * 60;

// Citation regex patterns. Components run to 6 digits: document-chunk markers
// encode the chunk's position ((page+1)*1000 + order) so two passages of one
// document can never mint the same marker; legacy 1-3 digit components (old
// persisted answers, entities, interactions, IODL rows) still match.
export const CITATION_REGEX = /\[((?:\d{4,7}\.\d{1,6}\s*,?\s*)+)\]/;
export const CITATION_REGEX_WITH_SPACE =
  /\s*\[((?:\d{4,7}\.\d{1,6}\s*,?\s*)+)\]/;
export const SIMPLE_CITATION_REGEX = new RegExp(
  String.raw`\[${CITATION_ID_PATTERN}\]`
);

// Admin organization ID for organization-wide workspace templates
export const ADMIN_ORG = "ADMIN_ORG";
